/* ORG-280 inserts «−10% on a full box»: 10 loose pieces of one code become one
 * hidden box variant (box product handle <piece handle>-box10, SKU <sku>-BOX10,
 * legacy -B10; priced at −10% off 10 pieces). Map piece→box
 * comes from the shop metafield custom.box10_map. It is NOT inlined (≈20 KB
 * once every insert has boxes, ORG-286): the page carries only its entry
 * count (window.BOX10_V) and ensure() fetches sections/box10-map.liquid via
 * ?sections= when the cart has items or a box product's page is open, cached
 * in sessionStorage per version for the rest of the session. Cart updates use
 * /cart/update.js: keys for existing lines, variant ids for box lines (a
 * variant id not in the cart is added). Quantities are absolute, so replaying
 * a plan built from a stale cart is harmless. Inert when the map is empty. */
(function (root) {
  // env: the global object (window) by default; tests pass a fake.
  function create(map, env) {
    var R = env || root;
    map = map || {};
    var boxes = {};
    function reindex() {
      boxes = {};
      Object.keys(map).forEach(function (p) { boxes[String(map[p])] = p; });
    }
    reindex();

    function plain(it) { return !it.properties || Object.keys(it.properties).length === 0; }
    function qtyOf(cart, vid) {
      var q = 0;
      cart.items.forEach(function (it) { if (String(it.variant_id) === String(vid) && plain(it)) q += it.quantity; });
      return q;
    }
    // ORG-391: a customer whose ΕΚΠΤΩΣΗ tier has no box deal (20% / Insize:
    // window.CUSTOMER_DISC.boxDeal false, set by layout/theme.liquid) never gets
    // boxes — plan() only unboxes: each box line back into 10 loose pieces (onto
    // the loose line when there is one). Guests and 5%/10% tiers box as usual;
    // Shopify stacks the 5%/10% on the box price.
    function off() { return !!R.CUSTOMER_DISC && !R.CUSTOMER_DISC.boxDeal; }
    // ORG-736 gift promos: `hold` = variant ids (pieces and boxes) the cart code planner
    // (assets/ekptosi-codes.js) keeps loose while a gift holder of their family is in the
    // cart — Shopify's gift code counts a box line as 1 piece. Held pieces are never boxed,
    // held boxes are unboxed. Set by the planner (api.hold); empty = box as before.
    var hold = [];
    function held(vid) { return hold.indexOf(String(vid)) > -1; }
    function unboxPlan(cart, only) {
      var updates = {}, any = false;
      cart.items.forEach(function (it) {
        var pieceId = boxes[String(it.variant_id)];
        if (pieceId == null || !plain(it) || it.quantity < 1) return;
        if (only && !only(it)) return;
        var loose = cart.items.find(function (x) { return String(x.variant_id) === String(pieceId) && plain(x); });
        var slot = loose ? loose.key : String(pieceId);
        updates[it.key] = 0;
        updates[slot] = (slot in updates ? updates[slot] : (loose ? loose.quantity : 0)) + 10 * it.quantity;
        any = true;
      });
      return any ? { updates: updates } : null;
    }
    function plan(cart) {
      if (off()) return unboxPlan(cart);
      var unbox = hold.length ? unboxPlan(cart, function (it) { return held(it.variant_id); }) : null;
      if (unbox) return unbox;
      var updates = {}, any = false;
      cart.items.forEach(function (it) {
        var boxId = map[String(it.variant_id)];
        if (!boxId || !plain(it) || it.quantity < 10 || held(it.variant_id)) return;
        var add = Math.floor(it.quantity / 10);
        updates[it.key] = it.quantity % 10;
        updates[String(boxId)] = (updates[String(boxId)] || qtyOf(cart, boxId)) + add;
        any = true;
      });
      return any ? { updates: updates } : null;
    }
    function minusPlan(pieceId, cart) {
      var loose = cart.items.find(function (it) { return String(it.variant_id) === String(pieceId) && plain(it); });
      if (loose && loose.quantity > 0) { var u = {}; u[loose.key] = loose.quantity - 1; return { updates: u }; }
      var boxId = String(map[String(pieceId)] || ''), b = qtyOf(cart, boxId);
      if (!boxId || b < 1) return null;
      var v = {}; v[boxId] = b - 1; v[String(pieceId)] = 9; return { updates: v };
    }
    function post(p) {
      var base = R.Shopify && R.Shopify.routes ? R.Shopify.routes.root : '/';
      return R.fetch(base + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(p)
      }).then(function (r) {
        // A 422 (box not sellable, deny policy…) must not count as success.
        if (!r.ok) throw new Error('cart/update.js ' + r.status);
        return r.json();
      });
    }
    function onCartPage() { return !!(R.location && /\/cart(\/|$|\?)/.test(R.location.pathname)); }
    // sessionStorage may be missing or throw (private mode, blocked storage).
    var GUARD = 'box10:reloaded';
    function store(op, val) {
      try {
        var ss = R.sessionStorage;
        if (!ss) return null;
        if (op === 'get') return ss.getItem(GUARD);
        if (op === 'set') ss.setItem(GUARD, val); else ss.removeItem(GUARD);
      } catch (e) { /* no storage: fall through */ }
      return null;
    }
    // The /cart page is server-rendered Liquid, so a drawer refresh would leave
    // its line table stale: reload it — but at most once per plan, so a plan
    // that survives the reload (the write silently did nothing) can't loop.
    // Everywhere else the drawer refresh re-renders and dispatches cart:updated.
    function afterWrite(sig) {
      if (onCartPage()) {
        if (sig && store('get') === sig) return R.CartDrawer ? R.CartDrawer.refresh() : undefined;
        if (sig) store('set', sig);
        return R.location.reload();
      }
      if (R.CartDrawer) return R.CartDrawer.refresh();
    }
    function fail(err) { if (R.console) R.console.error('[Box10]', err); }
    function emit(name) {
      if (R.document && typeof R.CustomEvent === 'function') R.document.dispatchEvent(new R.CustomEvent(name));
    }
    // busy spans POST + drawer refresh: line indices shift in between, so the
    // variants table ignores stepper clicks until 'box10:idle'.
    var busy = false, lastFailed = null;
    // Every Box10 write (normalize and minusOne) goes through here: busy from
    // POST start through afterWrite/refresh, events emitted, cleared in
    // finally (failures too). trackFail: remember a rejected normalize plan.
    function write(p, sig, trackFail) {
      busy = true;
      emit('box10:busy');
      return post(p)
        .then(function () { if (trackFail) lastFailed = null; return afterWrite(sig); },
              function (err) { if (trackFail) lastFailed = sig; throw err; })
        .catch(fail)
        .finally(function () { busy = false; emit('box10:idle'); });
    }
    // Lazy map: fill `map` IN PLACE (callers hold a reference to it).
    function load(obj) {
      Object.keys(map).forEach(function (k) { delete map[k]; });
      Object.keys(obj || {}).forEach(function (k) { map[k] = String(obj[k]); });
      reindex();
    }
    var loading = null;
    function ensure(version) {
      if (loading) return loading;
      var key = 'box10:map:' + version, cached = null;
      try { cached = R.sessionStorage && R.sessionStorage.getItem(key); } catch (e) { /* no storage */ }
      if (cached) {
        try { load(JSON.parse(cached)); return (loading = Promise.resolve()); } catch (e) { /* refetch */ }
      }
      var base = R.Shopify && R.Shopify.routes ? R.Shopify.routes.root : '/';
      loading = R.fetch(base + '?sections=box10-map', { headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('?sections=box10-map ' + r.status);
          return r.json();
        })
        .then(function (json) {
          var m = parseSectionMap(json);
          load(m);
          try { if (R.sessionStorage) R.sessionStorage.setItem(key, JSON.stringify(m)); } catch (e) { /* no storage */ }
        })
        .catch(fail);
      return loading;
    }
    var api = {
      map: map,
      load: load,
      ensure: ensure,
      get busy() { return busy; },
      get hold() { return hold.slice(); },
      set hold(ids) { hold = (ids || []).map(String); },
      held: held,
      get off() { return off(); },
      isBox: function (vid) { return String(vid) in boxes; },
      // Reverse lookup: the piece variant a box variant belongs to (or null).
      pieceFor: function (boxVid) { var p = boxes[String(boxVid)]; return p == null ? null : String(p); },
      totalQty: function (pieceId, cart) { return qtyOf(cart, pieceId) + 10 * qtyOf(cart, map[String(pieceId)] || ''); },
      plan: plan,
      minusPlan: minusPlan,
      // Resolves true when it wrote (the cart changed under the caller), else false.
      normalize: function (cart) {
        if (busy) return Promise.resolve(false);
        var p = plan(cart);
        if (!p) { if (onCartPage()) store('remove'); return Promise.resolve(false); }
        var sig = JSON.stringify(p);
        if (sig === lastFailed) return Promise.resolve(false); // don't hammer a rejected plan
        return write(p, sig, true).then(function () { return true; });
      },
      minusOne: function (pieceId, cart) {
        if (busy) return Promise.resolve();
        var p = minusPlan(pieceId, cart);
        return p ? write(p, JSON.stringify(p), false) : Promise.resolve();
      },
      // Nudge button: top a loose line up to 10 (change.js by line key), then
      // hand the returned cart to normalize, which turns it into a box and
      // reloads /cart or refreshes the drawer. If the shop capped the qty
      // (no plan), just refresh/reload so the page shows the real cart.
      // Ignored while busy; a non-ok response resolves silently.
      fillToBox: function (lineKey) {
        if (busy || !lineKey) return Promise.resolve();
        var base = R.Shopify && R.Shopify.routes ? R.Shopify.routes.root : '/';
        return R.fetch(base + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(lineKey), quantity: 10 })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart/change.js ' + r.status);
          return r.json();
        }).then(function (cart) {
          if (cart && cart.items && plan(cart)) return api.normalize(cart);
          return afterWrite(null);
        }).catch(fail);
      }
    };
    return api;
  }
  // The ?sections=box10-map response: {"box10-map": "<div …><script
  // type=application/json data-box10-map>{…}</script></div>"}.
  function parseSectionMap(json) {
    var html = json && json['box10-map'];
    var m = html && /<script[^>]*data-box10-map[^>]*>([\s\S]*?)<\/script>/.exec(html);
    if (!m) return {};
    try { return JSON.parse(m[1]) || {}; } catch (e) { return {}; }
  }
  // Box lines are recognised by their product handle (<piece handle>-box10),
  // never by the SKU: real codes end in -B10 too (ORG-713). The box SKU marker
  // is -BOX10 (legacy -B10); a box line shows its real piece code.
  function isBoxItem(item) {
    var h = String((item && (item.handle || item.url)) || '').split('?')[0];
    return /-box10$/.test(h);
  }
  function displaySku(item) {
    var sku = item && item.sku;
    if (sku == null) return sku;
    return isBoxItem(item) ? String(sku).replace(/-(BOX10|B10)$/, '') : String(sku);
  }
  // A box line links to its piece product: the hidden box product's handle is
  // <piece handle>-box10, so drop the query and a trailing -box10 from the
  // path; point at the piece variant when known.
  function pieceUrl(url, pieceVid) {
    if (!url) return url;
    var path = String(url).split(/[?#]/)[0].replace(/-box10$/, '');
    return pieceVid ? path + '?variant=' + encodeURIComponent(pieceVid) : path;
  }
  // WORK-295: how the staff drawer prices a box line, as listen bills it
  // (blueprints/staff_order.py box10_staff_pct): the bigger of the box 10% and the
  // line's own preset % (`ownPct`), never both. Own % up to 10 → the box deal alone,
  // nothing on top; above 10 → no box deal, the own % off the full 10-piece price
  // (box × 10/9). Loose lines keep what the cart charges and their own %.
  var BOX_PCT = 10;
  function staffDiscountBase(item, ownPct) {
    var base = item.final_line_price != null ? item.final_line_price : item.price * item.quantity;
    if (ownPct > BOX_PCT && isBoxItem(item)) {
      return Math.round((item.original_line_price != null ? item.original_line_price : base) * 10 / 9);
    }
    return base;
  }
  // The % the staff drawer takes off staffDiscountBase: 0 on a box line that keeps its deal.
  function staffLinePct(item, ownPct) {
    return isBoxItem(item) && !(ownPct > BOX_PCT) ? 0 : ownPct;
  }
  // Cart nudge: a loose line of 1–9 pieces is N short of a box (N = 10 − qty).
  function nudgeFor(qty) {
    var n = parseInt(qty, 10);
    return n >= 1 && n <= 9 ? 10 - n : null;
  }
  // Translated copy from the drawer's strings block (snippets/cart-drawer.liquid,
  // locales cart.box10.*); the Greek literals are the fallback.
  function T() {
    return (typeof window !== 'undefined' && window.CartDrawerStrings && window.CartDrawerStrings.box10) || null;
  }
  function fill(tpl, n, p) { return String(tpl).replace('__N__', n).replace('__P__', p); }
  // Nudge button text for a line N pieces short of a box.
  function fillLabel(n) { var t = T(); return t ? fill(t.fill, n) : '+' + n + ' → −10%'; }
  // Customer label for a box line of `qty` boxes (Greek storefront copy).
  function boxLabel(qty) {
    var n = Math.max(0, parseInt(qty, 10) || 0);
    var t = T();
    if (t) return { boxes: n === 1 ? t.boxesOne : fill(t.boxesMany, n, n * 10), sealed: t.sealed };
    return {
      // \u00A0 = no-break space: a number never ends a line apart from its word.
      boxes: n === 1 ? '1\u00A0κουτί (10\u00A0τεμ.)' : n + '\u00A0κουτιά (' + (n * 10) + '\u00A0τεμ.)',
      sealed: 'σφραγισμένο'
    };
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { create: create, parseSectionMap: parseSectionMap, displaySku: displaySku, isBoxItem: isBoxItem, pieceUrl: pieceUrl, boxLabel: boxLabel, nudgeFor: nudgeFor, fillLabel: fillLabel, staffDiscountBase: staffDiscountBase, staffLinePct: staffLinePct };
  }
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    window.Box10 = create({});
    window.Box10.displaySku = displaySku;
    window.Box10.isBoxItem = isBoxItem;
    window.Box10.pieceUrl = pieceUrl;
    window.Box10.boxLabel = boxLabel;
    window.Box10.nudgeFor = nudgeFor;
    window.Box10.fillLabel = fillLabel;
    window.Box10.staffDiscountBase = staffDiscountBase;
    window.Box10.staffLinePct = staffLinePct;
    // No boxes in the shop (entry count 0): stay inert, never fetch.
    var V = String(window.BOX10_V || '');
    if (!V || V === '0') return;
    // Load the map, then re-render the drawer from the cart it already holds
    // (its first render ran without the map: no nudge, box lines unlinked).
    var ready = null;
    function whenReady() {
      if (!ready) {
        ready = window.Box10.ensure(V).then(function () {
          if (window.CartDrawer && window.CartDrawer.rerender) window.CartDrawer.rerender();
          document.dispatchEvent(new CustomEvent('box10:ready'));
        });
      }
      return ready;
    }
    // A box product's page (variants table) needs the map for its steppers.
    if (window.BOX10_EAGER) whenReady();
    // «+N → −10%» buttons in the nudge (drawer + /cart): one delegated
    // handler; loading state on the button, restored when the write settles
    // (the drawer / page re-renders on success anyway).
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-box10-fill]');
      if (!btn) return;
      e.preventDefault();
      if (window.Box10.busy || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.disabled = true;
      window.Box10.fillToBox(btn.getAttribute('data-line-key')).then(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
    });
    // Empty cart → no fetch. The drawer refreshes on every page load, so a
    // cart with items loads the map right away (from sessionStorage after the
    // first page of the session).
    // /cart page: a box line's «−» takes one piece off (1 box → 9 loose),
    // like the drawer (ORG-297). Capture phase, so the theme's quantity
    // selector never sees the click (it would set the box count to qty − 1,
    // and at 1 its «−» is disabled). minusOne reloads /cart once written.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-box10-line] [data-quantity-minus]');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (window.Box10.busy) return;
      var row = btn.closest('[data-box10-line]');
      var boxVid = row && row.getAttribute('data-cartitem-id');
      whenReady().then(function () {
        var piece = window.Box10.pieceFor(boxVid);
        if (!piece) return;
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); })
          .then(function (c) { return window.Box10.minusOne(piece, c); });
      });
    }, true);
    // ORG-736: while a gift promo is live (window.PROMO_GIFT, layout/theme.liquid) the cart code
    // planner (assets/ekptosi-codes.js) calls normalize itself, after it has read which lines to
    // hold — boxing first and unboxing a moment later would cost two cart writes.
    function mine() { return !window.PROMO_GIFT; }
    window.Box10.whenReady = whenReady;
    document.addEventListener('cart:updated', function (e) {
      var c = e.detail && e.detail.cart;
      if (!c || !c.items || !c.items.length) return;
      whenReady().then(function () { if (mine()) window.Box10.normalize(c); });
    });
    // cart-drawer.js already turns cartcount:update into refresh → cart:updated;
    // only fetch ourselves when the drawer isn't on the page.
    window.addEventListener('cartcount:update', function () {
      if (window.CartDrawer || !mine()) return;
      fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); })
        .then(function (c) { return whenReady().then(function () { window.Box10.normalize(c); }); });
    });
  }
})(typeof window !== 'undefined' ? window : globalThis);
